import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveListAction from './collectionIncentiveList.action.json' with { type: 'json' }
import { collectionIncentiveObject } from '../collectionIncentiveObject'
import { enumerated } from '~/prix/types/enumerated'

const collectionIncentiveListDefinition = defineAction({
  ...collectionIncentiveListAction,

  input: z.object({
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      totalQuantity: 'Quantidade total',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(collectionIncentiveObject), count: z.number() }),
})

export default collectionIncentiveListDefinition
